import { AppStateEnum } from '../../main/types/app-state.types.ts';
import { StepType } from '../../main/types/asset/asset.enums.ts';
import { createMemoizedSelector } from '../../main/utils/selector/create-memoized-selector.ts';

import { KeyWordType } from '../slices/story-reading/story-reading.slice.types.ts';
import { StorySentenceBallAnimationPositions } from '../types/story-sentence-animation.types.ts';

import { selectAnimationPrerequisites } from './story-sentence-ball-animation-prerequisites.selector.ts';

export const selectAnimationPositions = createMemoizedSelector(
  selectAnimationPrerequisites,
  (prerequisites): StorySentenceBallAnimationPositions | null => {
    const { keyWordPositions, step, appState } = prerequisites;

    if (keyWordPositions === null) {
      return null;
    }

    const firstWordPosition = keyWordPositions[KeyWordType.STEP_FIRST_WORD];
    const lastWordPosition = keyWordPositions[KeyWordType.STEP_LAST_WORD];
    const beforeTransitionWordPosition = keyWordPositions[KeyWordType.STEP_BEFORE_TRANSITION_WORD];
    const afterTransitionWordPosition = keyWordPositions[KeyWordType.STEP_AFTER_TRANSITION_WORD];

    if (!firstWordPosition) {
      return null;
    }

    if (step.stepType === StepType.BothReadSentence) {
      if (appState === AppStateEnum.Recording) {
        return {
          startPosition: afterTransitionWordPosition ?? firstWordPosition,
          finalPosition: lastWordPosition ?? firstWordPosition,
        };
      } else if (appState === AppStateEnum.Playing && beforeTransitionWordPosition) {
        return {
          startPosition: firstWordPosition,
          finalPosition: beforeTransitionWordPosition,
        };
      }
    }

    const startPosition = firstWordPosition;
    const finalPosition = lastWordPosition ?? firstWordPosition;

    return {
      startPosition,
      finalPosition,
    };
  }
);
